import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchRecordsBlocks } from '../../lib/api';

export function useRecordsBlocks(constituencyId, campaignId) {
  return useQuery({
    queryKey: queryKeys.recordsBlocks(constituencyId, campaignId),
    queryFn: () => fetchRecordsBlocks(constituencyId, campaignId),
    enabled: !!(constituencyId && campaignId),
  });
}
